export default function AboutArtist() {
  return (
    <section id="about-artist" className="relative py-32 px-6 md:px-12 lg:px-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-center">
          {/* Portrait */}
          <div className="relative h-[600px] lg:h-[700px] overflow-hidden">
            <div className="absolute inset-0 ken-burns">
              <img
                src="https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/01c6a652d6e6150beaafd698fb2a750e.png"
                alt="Canadian Nightmares Artist"
                className="w-full h-full object-cover grayscale"
                style={{ filter: 'grayscale(100%) contrast(1.2)' }}
              />
              <div className="absolute inset-0 bg-[#ff0033]/15 mix-blend-multiply"></div>
              <div className="absolute inset-0 grain-texture"></div>
            </div>
          </div>

          {/* Vertical Red Line */}
          <div className="hidden lg:block absolute left-1/2 top-1/2 w-px h-4/5 bg-[#ff0033] transform -translate-x-1/2 -translate-y-1/2"></div>

          {/* Biography Content */}
          <div className="lg:pl-20 py-12 lg:py-0">
            <p className="text-[11px] tracking-widest text-[#4dd0e1] font-semibold uppercase mb-6">
              About
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
              CANADIAN NIGHTMARES
            </h2>
            
            <div className="space-y-6 text-base md:text-lg text-gray-300 leading-loose max-w-xl">
              <p>
                The goal is simple: turn the strange, frustrating, and sometimes absurd moments of modern Canadian life into music that feels sharp, atmospheric, and impossible to ignore.
The project focuses on storytelling through sound—combining elements of rock, electronic production, and dramatic themes to create tracks that feel more like scenes from a film than traditional songs. Each release explores a different &quot;nightmare&quot;: corruption, hypocrisy, cultural contradictions, or the uneasy feeling that something about the system is not quite right.
Rather than presenting politics in a traditional way, Canadian Nightmares approaches it as dark theatre. Characters, symbolism, and satire are used to highlight issues while still keeping the music entertaining and engaging.
              </p>
              <p>
                Canadian Nightmares is not about telling people what to think.
It is about holding up a mirror—and letting the nightmare speak for itself.
              </p>
              
              <p>
                Canadian Nightmares has been featured in underground electronic music festivals and has garnered a dedicated following among fans of dark, atmospheric soundscapes.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 mt-12 pt-12 border-t border-gray-800">
              <div>
                <p className="text-3xl font-bold text-white mb-2">1</p>
                <p className="text-sm text-gray-400 uppercase tracking-wider">Albums</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-white mb-2">14</p>
                <p className="text-sm text-gray-400 uppercase tracking-wider">Tracks</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-white mb-2">TBD</p>
                <p className="text-sm text-gray-400 uppercase tracking-wider">Streams</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}